module.exports = __webpack_public_path__ + "static/assets/e9fd9649a5e891c8811243c4543e986e.png";